import { useEffect, useRef, RefObject } from 'react'

import { animateReveal, scrollIntoView } from './complianceAnimations'

/** Ref for content that should animate in and scroll into view via GSAP the
 *  moment `active` flips true — e.g. a summary card revealed on completion
 *  that can land below the fold. Fires once per false→true transition, not
 *  on every render while already active. */
export const useScrollIntoViewOnReady = (
  active: boolean
): RefObject<HTMLDivElement> => {
  const ref = useRef<HTMLDivElement>(null)
  // Seeded from the current value, not `false`: `IntakeSection` is keyed by
  // section, so arriving at an already-complete section mounts this fresh and
  // a `false` seed would read as a false→true transition, animating and
  // scrolling a summary card that was already settled.
  const wasActive = useRef(active)

  useEffect(() => {
    if (active && !wasActive.current && ref.current) {
      animateReveal(ref.current)
      scrollIntoView(ref.current)
    }
    wasActive.current = active
  }, [active])

  return ref
}
